// extracted by mini-css-extract-plugin
module.exports = {"container":"edit_container__3DSS2","editor":"edit_editor__2-vuA","toolbar":"edit_toolbar__18Xk0"};